var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "32px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M682.666667 938.666667l-128-42.666667 12.8-170.666667 115.2 128zM896 725.333333l-320-157.866666-4.266667-149.333334-4.266666-98.133333L896 644.266667zM341.333333 938.666667l128-42.666667-12.8-170.666667-115.2 128zM128 725.333333l320-157.866666 4.266667-149.333334 4.266666-98.133333L128 644.266667z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 85.333333c-46.933333 0-85.333333 38.4-85.333333 85.333334v704c0 23.466667 19.2 42.666667 42.666666 42.666666h85.333334c23.466667 0 42.666667-19.2 42.666666-42.666666V170.666667c0-46.933333-38.4-85.333333-85.333333-85.333334z",
    fill: "#64B5F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M490.666667 725.333333h42.666666v192h-42.666666z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.edbb15d1632fd6ab9113d526a0336bd1.svg";
export { ForwardRef as ReactComponent };